export const StartRoute = '/start';
export const RequestRoute = '/:id';
export const calcRequestRoute = (id: string) => RequestRoute.replace(':id', id);